import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import download1Image from "../../assests/images/download (1).png";
import trophyImage from "../../assests/images/rank-trophy.png";
import msgIco from "../../assests/images/msg-ico.png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { rfqServices } from "../../services/rfqServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { inrDateFormatNoTime, isEmptyDash, urlConstants, trimString, toInr, totalInr, toFixedNum } from "../../constant";
import SupportChat from "../support/chat";
import _ from "lodash";
import PackageDocuments from "../projectManagerScreens/packageDocuments";
import { UserObj } from "../../services/localStarage";
import { onboardingServices } from "../../services/onboardingServices";
import { strToDate } from "../../constant";
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import back from "../../assests/images/back.png";
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CommercialComparison() {

  const { id } = useParams();
  let navigate = useNavigate();
  const [commercialEvaluationDetails, setCommercialEvaluationDetails] = React.useState({
    boqs: [],
    rfqVendors: [],
  });
  const [document, setDocument] = React.useState({
    documentName: "Reverse Auction Documents",
    response: [],
  });
  const [rfqDetails, setRfqDetails] = React.useState({
    boqs: [],
    documents: [],
    rounds: [],
    rfqVendors: [],
    rfqValidity: { "from": null, "to": null },
  });
  const [activeChatVendorId, setActiveChatVendorId] = useState("");
  const [isEditManually, setIsEditManually] = React.useState(false);
  const [isMediaUploadSecName, setIsMediaUploadSecName] = React.useState("");

  const [opencreaterfqnewtoggler, setOpenCreateRfqnewToggler] = useState("Header");
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [openDownloadResultmodal, setOpenDownloadResultModal] = useState(false);

  const [selectedCheckBox, setSelectedCheckBox] = useState("");
  const [isReverseFileUploaded, setIsReverseFileUploaded] = useState(false);
  const [showalldocuments, setshowalldocuments] = React.useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isVendorChatBoxOpen, setIsVendorChatBoxOpen] = useState(false);
  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    getCommercialComparison(id);
    getRFQDetails(id);
  }, []);

  const getCommercialComparison = (param) => {
    setIsLoading(true);
    let round = 2;
    let promise = rfqServices.getCommercialComparison(param,round);

    promise.then((res) => {
      if (res.data.success === true) {
        let resData = res.data.data;
        
        for (let i = 0; i < resData?.rfqVendors.length; i++) {
          let arr = [];
          for (let j = 0; j < resData?.documents.length; j++) {
            for (let k = 0; k < resData?.rfqVendors[i]?.documents.length; k++) {
              if (resData?.documents[j]?.uniqueName == resData?.rfqVendors[i]?.documents[k]?.uniqueName) {
                arr.push(resData?.rfqVendors[i]?.documents[k]);
              }              
            }
          }
          // console.log("getCommercialComparison", arr);
          resData.rfqVendors[i].documents = arr;
        }
        
        // resData["boqTableArr"] = createTableArr(res.data.data);
        setCommercialEvaluationDetails(resData);
        setActiveChatVendorId(resData?.rfqVendors?.[0]?.vendorId);
        // setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getRFQDetails = (param) => {
    setIsLoading(true);
    let data = `/${param}`;
    let promise = rfqServices.getRfqListing(data);

    promise.then((res) => {
      if (res.data.success === true) {
        setRfqDetails(res.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getRfqVendorBoqByBoqId = (boqId, rfqVendorsBoqsArr) => {
    let obj = {};
    // Check if rfqVendorsBoqsArr is an array and has elements
    if (Array.isArray(rfqVendorsBoqsArr) && rfqVendorsBoqsArr.length > 0) {
      for (let i = 0; i < rfqVendorsBoqsArr.length; i++) {
        if (boqId == rfqVendorsBoqsArr[i]?.boqId) {
          obj["data"] = rfqVendorsBoqsArr[i];
          obj["index"] = i;
        }
      }
    }
    return obj;
  }


  const getRfqVendorDiff = (boqId, rfqVendorsBoqsArr1, rfqVendorsBoqsArr2) => {
    // let obj = {};
    let total1 = 0;
    let total2 = 0;
    for (let i = 0; i < rfqVendorsBoqsArr1.length; i++) {
      if (boqId == rfqVendorsBoqsArr1[i]?.boqId) {
        total1 = Number(rfqVendorsBoqsArr1[i]?.amount) || 0;
      }
    }
    for (let i = 0; i < rfqVendorsBoqsArr2.length; i++) {
      if (boqId == rfqVendorsBoqsArr2[i]?.boqId) {
        total2 = Number(rfqVendorsBoqsArr2[i]?.amount) || 0;
      }
    }
    if (total1 === 0) {
      return "N/A"; // Return 'N/A' if total1 is zero to avoid NaN
    }
    let totalDiff = (total2 - total1) * 100 / total1;
    return totalDiff.toFixed(0);
  }

  const onLineItemChange = (e, boqIdx, venorIdx, boq_id) => {
    let rfqVendorsInit = _.cloneDeep(commercialEvaluationDetails?.rfqVendors);
    let { name, value } = e.target;
    rfqVendorsInit[venorIdx].boqs[1].boqData[boqIdx].amount = Number(commercialEvaluationDetails?.boqs[boqIdx].quantity) * Number(value);
    rfqVendorsInit[venorIdx].boqs[1].boqData[boqIdx].rate = Number(value);

    setCommercialEvaluationDetails((prevState) => ({
      ...prevState,
      rfqVendors: rfqVendorsInit,
    }));
  }

  const onTotalChange = (e, venorIdx) => {
    let rfqVendorsInit = _.cloneDeep(commercialEvaluationDetails?.rfqVendors);
    let { name, value } = e.target;
    rfqVendorsInit[venorIdx].boqs[1].totalAmount = value;

    setCommercialEvaluationDetails((prevState) => ({
      ...prevState,
      rfqVendors: rfqVendorsInit,
    }));
  }

  const isTotalDisable = (param) => {
    let isValid = true;
    for (let i = 0; i < param?.boqData.length; i++) {
      if (!isEmptyDash(param?.boqData[i]?.rate)) {
        isValid = false;
      }
    }
    return isValid;
  }

  const handleClick = () => {
    setDocument({
      documentName: "Reverse Auction Documents",
      response: [],
    });
    setIsMediaListModalOpen(true);
    setIsMediaUploadSecName("Reverse_Auction");
  }

  const closeMediaListModal = () => {
    setIsMediaListModalOpen(false);
    if (isMediaUploadSecName == "") {
      setDocument({
        documentName: "Reverse Auction Documents",
        response: [],
      });
    }
    // setIsMediaUploadSec(false);
  };

  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

  const onUploadMedia = (resData, uploadObj, files) => {
    let obj = {
      key: encodeKey(resData?.data?.Key),
      fileName: files?.name,
    };
    uploadObj.response.push(obj);
    setDocument(uploadObj);
  };

  const deleteFile = (index, key, idx) => {
    const updatedFiles = document.response.filter((file, i) => i !== index);
    const obj = { ...document, response: [...updatedFiles] };
    setDocument(obj);
  };

  const onClearData = () => {
    getCommercialComparison(id);
  }

  const handleUploadStatus = (status) => {
    setIsReverseFileUploaded(status);
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const onSubmitData = () => {
    if (commercialEvaluationDetails?.reverseAuctionUploaded !== true && !isReverseFileUploaded) {
      openAlert(true, "error", `Please Upload Reserve Auction Results`);
      return;
    }
    setIsLoading(true);
    let bodyData = {
      "reverseAuctionResults": [...document?.response],
      "round": 2,
      "vendorData": [],
    };
    let isTotalValid = true;

    for (let i = 0; i < commercialEvaluationDetails?.rfqVendors.length; i++) {
      let obj = {
        "vendorId": commercialEvaluationDetails?.rfqVendors[i]?.vendorId,
        "headerLevel": true,
        "boqs": [...commercialEvaluationDetails?.rfqVendors[i]?.boqs?.[1]?.boqData],
        "totalAmount": Number(commercialEvaluationDetails?.rfqVendors[i]?.boqs[1]?.totalAmount),
      }
      if (rfqDetails?.status == "Round_2_Published") {
        obj.headerLevel = false;
        let totalSum = 0;
        for (let j = 0; j < obj.boqs.length; j++) {
          totalSum += Number(obj.boqs[j]?.amount);
        }
        if (totalSum > (obj.totalAmount + 20) || totalSum < (obj.totalAmount - 20)) {
          isTotalValid = false;
        }
      }
      else {
        if (isEmptyDash(commercialEvaluationDetails?.rfqVendors[i]?.boqs[1]?.totalAmount) || commercialEvaluationDetails?.rfqVendors[i]?.boqs[1]?.totalAmount == 0) {
          obj.headerLevel = false;
        }
      }
      bodyData.vendorData.push(obj);
    }

    if (isTotalValid == false) {
      setAlertComponent({ open: true, type: "error", message: `Total sum of amount should be around total value` });
      setIsLoading(false);
      return;
    }

    let promise = rfqServices.updateReverseAuctionRound2(id, bodyData);
    promise.then((res) => {
      if (res.data.success === true) {
        setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
        navigate(`/admin/Buyer-Bidding-Rfq-Creaction-Form/${id}`);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });


  }
  const [hasRedirected, setHasRedirected] = useState(false);
  const downloadRfqResult = (param) => {
    setIsLoading(true);
    let bodyData = {
      "type": selectedCheckBox,
      "round": 2
    };

    let url = `${urlConstants.BASE_URI_DEV}/v1/internal/rfqs/${id}/commercial-comparison/download`;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify(bodyData);

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(url, requestOptions)
      .then(response => response.blob())
      .then(blob => {
        const link = window.document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let fileName = "";
        if (selectedCheckBox == "Pdf") {
          fileName = `Bidding-R2-${rfqDetails?.rfqNumber}.pdf`;
        }
        if (selectedCheckBox == "Excel") {
          fileName = `Bidding-R2-${rfqDetails?.rfqNumber}.xlsx`;
        }
        if (selectedCheckBox == "Both") {
          fileName = `Bidding-R2-${rfqDetails?.rfqNumber}.zip`;
        }
        link.download = fileName;
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
        onFinalizeSubmit();
        // Redirect only if it has not already been redirected
        if (!hasRedirected) {
          setHasRedirected(true);
          navigate(`/admin/Engineering-Bidding-Rfq-Listing`);
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const onFinalizeSubmit = (e) => {
    setIsLoading(true);
    let bodyData = {
      "type": "Commercial",
      "round": 2
    };
    let promise = rfqServices.techFinalize(id, bodyData);

    promise.then((res) => {
      if (res.data.success === true) {
        setOpenDownloadResultModal(false);
        setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
        // window.location.reload();
        // setOpenFinalizeEvaluationSuccessfully(true);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const onSelectedCheckBox = (e, param) => {
    setSelectedCheckBox(param);
  }
  const vendorChatBoxClick = (vendorId) => {
    setActiveChatVendorId(vendorId);
    setIsVendorChatBoxOpen(true); /** for chatbox open from vendor side */
  }
  const handleChatboxMinimize = () => {
    setIsVendorChatBoxOpen(false);
  };
  const downloadAttachment = (data, fileNameParam, secName, vendorIndex, attachmentIndex) => {
    setIsLoading(true);
    onboardingServices.viewUrlData(data).then(function (response) {
      const url = response?.data?.data?.url;
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileNameParam;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(error => console.error('Error downloading Doc:', error))
        .finally((param) => {
          setIsLoading(false);
        });
    });
  }
  function formatFileName(fileName, maxLength = 10) {
    if (!fileName || typeof fileName !== 'string') {
      return '';
    }
    if (fileName.length <= maxLength) {
      return fileName;
    }
    const startLength = Math.ceil(maxLength / 2);
    const endLength = Math.floor(maxLength / 2) - 3;
    const startText = fileName.substring(0, startLength);
    const endText = fileName.substring(fileName.length - endLength);
    return `${startText}...${endText}`;
  }
  const handleClick1 = (document, index) => {
    setDocument(document);
    setIsMediaListModalOpen(true);
    setIsMediaUploadSecName("");
  }
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div class="div-details-center react_technical_vendordetail22">
            <button
              onClick={() => navigate(-1)}
              class=""
              style={{
                padding: "9px 16px",
                marginRight: "11px",
                fontSize: "18px",
                background: "black",
              }}
            >
              <img
                src={back}
                alt="back-button"
                style={{ paddingRight: "3px" }}
              />{" "}
              Back
            </button> </div>
          <div className="listing_projectss">

            <p className="listing_rfq">
              Commercial Comparison
              <strong className="bidding_round_rfq">- Bidding Round 2</strong>
            </p>
            <div className="extend_evaluation">
              {(rfqDetails?.status !== "Round_2_Completed") && (
                <>
                  {commercialEvaluationDetails?.reverseAuctionUploaded !== true && (
                    <button
                      className="vendor_btn vendor_maine_content2"
                      onClick={handleClick}
                    >
                      Upload Reverse Auction Results
                    </button>
                  )}


                  {!isEditManually && (
                    <button
                      className="vendor_btn vendor_maine_content2"
                      onClick={() => setIsEditManually(true)}
                    >
                      Update Result Manually
                    </button>
                  )}
                </>
              )}

              {(rfqDetails?.status == "Round_2_Initiated" || rfqDetails?.status == "Round_2_Completed") && <button
                className="btn btn-success save_next_btns"
                onClick={() => {
                  setOpenDownloadResultModal(true)
                }}
              >
                <DownloadIcon />
                Download Result
              </button>}

            </div>
          </div>


          <div class="header_lineitem">
            <span
              onClick={() => setOpenCreateRfqnewToggler("Header")}
              class={
                opencreaterfqnewtoggler === "Header"
                  ? "line-tb"
                  : "header-tb"
              }
            >
              Header
            </span>
            <span
              onClick={() => setOpenCreateRfqnewToggler("LineItems")}
              class={
                opencreaterfqnewtoggler === "LineItems"
                  ? "line-tb"
                  : "header-tb"
              }
            >
              Line Items
            </span>
          </div>
          <div className="row1_firstcommercial_bpdt_section_react_roq">
            <table className="table table-bordered tble-sty vendor_rfqdetail_technical_body_row2" style={{ tableLayout: 'fixed' }}>
              <thead>
                <tr className="line_time_rfq_project_detail_body">
                  <th className="boq_detail_technical_package_react" style={{ width: '32px' }}>No</th>
                  <th className="boq_detail_technical_package_react" style={{ width: '126px', textAlign: 'center' }}>BOQ</th>
                  <th className="boq_detail_technical_package_react">QTY</th>
                </tr>
              </thead>
              <tbody>

                {commercialEvaluationDetails?.boqs?.map((boqsEle, i) => <>
                  <tr>
                    <td>{i + 1}</td>
                    <td className="vendor_c_reacts_package_blocklist_trews" style={{ height: isEditManually ? "54px" : "auto" }}>
                      <p>
                        <Tooltip title={boqsEle?.description}> <b>{trimString(boqsEle?.description, 12)} </b></Tooltip>
                      </p>
                    </td>
                    <td style={{ height: isEditManually ? "54px" : "auto" }}>{boqsEle?.quantity}</td>
                  </tr>
                </>)}


                <tr>
                  <td className="vendor_f_react_body_list_detail"></td>
                  <td className="vendor_f_react_body_list_detail" style={{ height: "54px" }}>
                    <h2 className="lets_total_reactdetail_blocklist_roundq">
                      Total
                    </h2>
                  </td>
                  <td className="vendor_f_react_body_list_detail">
                    <h2 className="lets_total_reactdetail_blocklist_roundq">
                      {commercialEvaluationDetails?.totalQuantity}
                    </h2>
                  </td>
                </tr>
                {/* <tr className="custom-borders">
                  <td className="border-top border-bottom text-end">
                    <p className="tender_drawing_f">
                      <b>Tender Drawing</b>
                    </p>
                    <p className="tender_drawing_f">
                      <b style={{ fontSize: "13px" }}>Technical Specification</b>
                    </p>
                  </td>
                  <td></td>
                </tr> */}

                {/* <tr class="custom-borders">
                  <td class="border-top border-bottom  technical_soon_div_tdf_reacts">
                    <input type="checkbox" />

                    <p className="tender_drawing_f">
                      <b>Payment Terms</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Liquidated Damages</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Over all LD cap</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Defect Liability Period</b>
                    </p>
                  </td>
                  <td></td>
                </tr>

                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Service Contract </b>
                    </p>
                  </td>
                  <td></td>
                </tr>

                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Warranty</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"

                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Capacity</b>
                    </p>
                  </td>
                  <td></td>
                </tr> */}

                <tr class="custom-borders">
                  <td></td>
                  <td class="border-top border-bottom  technical_soon_div_tdf_reacts"  >

                    <p className="tender_drawing_fs" onClick={() => setshowalldocuments(!showalldocuments)}>
                      <b >View All Attachment</b>
                      {showalldocuments ? <RemoveIcon /> : <AddIcon />}
                    </p>
                  </td>
                  <td style={{ border: "none" }}></td>
                </tr>
                {showalldocuments ? <>

                  {commercialEvaluationDetails?.documents?.map((rfqVendorsDocEle, i) => <>
                    <tr class="custom-borders">
                      <td></td>
                      <td
                        class="border-top border-bottom technical_soon_div_tdf_reacts"
                        style={{ height: "50px" }}
                      >

                        <p className="tender_drawing_f">
                          <Tooltip title={rfqVendorsDocEle?.documentName}> <b>{trimString(rfqVendorsDocEle?.documentName, 13)}</b></Tooltip>
                        </p>
                      </td>
                      <td></td>
                    </tr>
                  </>)}

                </> : null}

              </tbody>
            </table>

            <div className="react_row_table_technical_body">
              <table className="table table-bordered tble-sty vendor_rfqdetail_technical_body ">
                <thead>
                  <tr className="line_time_rfq_project_detail_body">

                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <th className="lets_oty_listing_detail_r_line" style={(rfqVendorsEle?.technicalStatus === 'Rejected' || rfqVendorsEle?.participationStatus === 'Rejected') ? { backgroundColor: '#808080ad' } : {}}>
                        <div className="vendor_b_react_package_blocklist_body">
                          <p className="vendor_a_react_body_list">{rfqVendorsEle?.vendorName}</p>
                          <div>
                            {/* <span className="rank-trophy">{j+1}</span> */}
                            {/* <span onClick={() => setActiveChatVendorId(rfqVendorsEle?.vendorId)}> */}
                            <span onClick={() => vendorChatBoxClick(rfqVendorsEle?.vendorId)}>
                              <img className="msgIco-img" src={msgIco} alt="" />
                            </span>

                            {(opencreaterfqnewtoggler == "Header") && <div>
                              <span className="rank-trophy">{j + 1}</span>
                              <span>
                                <img className="rank-trophy-img" src={trophyImage} alt="" />
                              </span>
                            </div>}
                          </div>


                        </div>
                        {rfqVendorsEle?.technicalStatus === 'Rejected' ? 'Technical Evaluation : Rejected' : '' || rfqVendorsEle?.participationStatus === 'Rejected' ? 'Participation Status: Rejected' : ''}
                        <p class="bidding_block_sky"> {strToDate(rfqVendorsEle?.updatedAt)}</p>
                        <div className="bidding_buyer_initeate_react_body">
                          <div className="rate_evalulation_listing_react_body">
                            {(rfqDetails?.status == "Round_2_Initiated" || rfqDetails?.status == "Round_2_Completed") && <div className="w-100">
                              <h6>Round 1</h6>
                              <div className="rate_evalulation_listing_react_body">
                                <div>
                                  <h6>Rate</h6>
                                </div>
                                <div className="round_listing">
                                  <h6 style={{ marginRight: "10px" }}>Amount</h6>
                                </div>
                              </div>
                            </div>}

                            <div className="w-100">
                              {(rfqDetails?.status == "Round_2_Initiated" || rfqDetails?.status == "Round_2_Completed") && <h6>Round 2</h6>}
                              <div className="rate_evalulation_listing_react_body">
                                <div>
                                  <h6>Rate</h6>
                                </div>
                                <div className="round_listing">
                                  <h6 className="digit-h6-sec">Amount</h6>
                                  <h6 className="digit-h6-sec" >{"  "}</h6>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                      </th>
                    </>)}

                  </tr>
                </thead>
                <tbody>

                  {commercialEvaluationDetails?.boqs?.map((boqsEle, i) => <>
                    <tr>
                      {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>

                        <td style={(rfqVendorsEle?.technicalStatus === 'Rejected' || rfqVendorsEle?.participationStatus === 'Rejected') ? { backgroundColor: '#808080ad' } : {}}>
                          {" "}
                          {(rfqDetails?.status == "Round_2_Initiated" || rfqDetails?.status == "Round_2_Completed") && <div className="bidding_buyer_initeate_react_body">
                            <div className="rate_evalulation_listing_react_body">
                              {(rfqDetails?.status == "Round_2_Initiated" || rfqDetails?.status == "Round_2_Completed") && <div className="w-100">
                                <div className="rate_evalulation_listing_react_body">
                                  <div>
                                    <h6>
                                      {/* ₹ {getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rate} */}
                                      {(() => {
                                        const rate = getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rate;
                                        return rate ? `₹ ${rate}` : "";
                                      })()}
                                    </h6>
                                  </div>
                                  <div className="round_listing">
                                    <h6 style={{ marginRight: "10px" }}>

                                      {/* ₹ {getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.amount} */}
                                      {(() => {
                                        const amount = getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.amount;
                                        return amount ? `₹ ${amount}` : "";
                                      })()}
                                    </h6>
                                  </div>
                                </div>
                              </div>}

                              <div className="w-100">
                                <div className="rate_evalulation_listing_react_body">
                                  {(isEditManually != true) && <div className="round_listing">
                                    <h6 style={{ marginRight: "10px" }}>

                                      {/* ₹ {getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[1]?.boqData)?.data?.rate} */}

                                      {(() => {
                                        const rate = getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[1]?.boqData)?.data?.rate;
                                        return rate ? `₹ ${rate}` : "";
                                      })()}

                                    </h6>
                                  </div>}
                                  {(isEditManually == true) && <div>
                                    <input
                                      class="form-control form-hase-vendors_div_reacfs"
                                      type="number"
                                      // disabled={!(isEditManually == true )}
                                      value={getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[1]?.boqData)?.data?.rate}
                                      onChange={(e) => onLineItemChange(e, i, j, boqsEle?._id)}
                                      // placeholder="₹ 500" 
                                      disabled={rfqVendorsEle?.technicalStatus === 'Rejected' || rfqVendorsEle?.participationStatus === 'Rejected'}
                                    />
                                  </div>}

                                  <div className="round_listing">
                                    <h6 className="digit-h6-sec" >

                                      {/* ₹ {getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[1]?.boqData)?.data?.amount} */}
                                      {(() => {
                                        const amount = getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[1]?.boqData)?.data?.amount;
                                        return amount ? `₹ ${totalInr(amount)}` : "";
                                      })()}
                                    </h6>
                                    <h6 className="digit-h6-sec" >
                                      {/* {getRfqVendorDiff(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData, rfqVendorsEle?.boqs[1]?.boqData)}% */}
                                      {(() => {
                                        const diff = getRfqVendorDiff(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData, rfqVendorsEle?.boqs[1]?.boqData);
                                        return diff !== "N/A" ? `${toFixedNum(diff,2)}%` : '';
                                      })()}
                                    </h6>
                                  </div>

                                </div>
                              </div>

                            </div>
                          </div>}

                          {(rfqDetails?.status == "Round_1_Completed") && <div className="d-flex justify-content-between gap-2">
                            <div className="evaluation_react_bvfdt_div_block1">
                              <input
                                className="form-control form-hase-vendors_div_reacfs"
                                type="number"
                                disabled={
                                  !(
                                    isEditManually === true &&
                                    opencreaterfqnewtoggler === "LineItems" &&
                                    (rfqVendorsEle?.boqs[1]?.totalAmount === 0 || isEmptyDash(rfqVendorsEle?.boqs[1]?.totalAmount))
                                  ) || rfqVendorsEle?.technicalStatus === 'Rejected' || rfqVendorsEle?.participationStatus === 'Rejected'
                                }
                                value={getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[1]?.boqData)?.data?.rate}
                                onChange={(e) => onLineItemChange(e, i, j, boqsEle?._id)}
                              // placeholder="₹ 500"
                              />

                            </div>

                            <div className="evaluation_react_bvfdt_div_block1">
                              <input
                                class="form-control form-hase-vendors_div_reacfs"
                                type="text"
                                disabled
                                value={getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[1]?.boqData)?.data?.amount}
                              // placeholder="₹ 500"
                              />
                            </div>
                          </div>}



                          {/* <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">
                              <span class="bidding_block_rate ">
                                ₹ {isEmptyDash(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rate)? 0 : getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rate}
                              </span>
                            </div>

                            <div className="evaluation_react_bvfdt_div_block1">
                              <span class="bidding_block_rate ">
                                ₹ {isEmptyDash(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.amount)? 0 : getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.amount}
                              </span>
                              
                              {(opencreaterfqnewtoggler == "LineItems") && <>
                                {!(isEmptyDash(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rank)) && <div>
                                  <span className="rank-trophy">
                                    {getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rank}
                                  </span>
                                  <span>
                                    <img className="rank-trophy-img" src={trophyImage} alt="" />
                                  </span>
                                </div>}
                              </>}
                            </div>
                                                        
                          </div> */}
                        </td>
                      </>)}
                    </tr>
                  </>)}


                  <tr>
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td className="vendor_f_react_body_list_detail">
                        <div className="total_vendor_round_detail_panel_q">
                          {/* <h2 className="lets_total_reactdetail_blocklist_roundq"></h2>
                            <h2 className="lets_total_reactdetail_blocklist_roundq me-4 ">
                              {rfqVendorsEle?.boqs[0]?.totalAmount}dfgsdf
                            </h2> */}
                          <div className="evaluation_react_bvfdt_div_block1">

                          </div>
                          <div className="evaluation_react_bvfdt_div_block1">
                            {/* <h6 className="digit-h6-sec" >{rfqVendorsEle?.boqs[1]?.totalAmount}</h6> */}
                            <input
                              className="form-control form-hase-vendors_div_reacfs"
                              type="number"
                              disabled={
                                !(isEditManually === true &&
                                  opencreaterfqnewtoggler === "Header" &&
                                  isTotalDisable(rfqVendorsEle?.boqs[1])
                                ) || rfqVendorsEle?.technicalStatus === 'Rejected' || rfqVendorsEle?.participationStatus === 'Rejected'
                              }
                              value={rfqVendorsEle?.boqs[1]?.totalAmount}
                              onChange={(e) => onTotalChange(e, j)}
                            // placeholder="₹ 500"
                            />

                          </div>
                        </div>

                      </td>

                    </>)}

                  </tr>
                  {/* <tr className="custom-borders">

                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, i) => <>
                      <td>
                        <div className="lets_customs_div_reacts_round1">
                          <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">
                              {(rfqVendorsEle?.tendorDrawing?.length < 1) && <>
                                <p className="tender_drawing_f">Empty</p>
                              </>}
                              {rfqVendorsEle?.tendorDrawing?.map((attachmentEle, j) => <>
                                <p className="tender_drawing_f" onClick={() => downloadAttachment(attachmentEle?.key, attachmentEle?.fileName, "tendorDrawing", i, j)}>
                                  {attachmentEle?.fileName} <img src={download1Image} alt="" />
                                </p>
                              </>)}

                            </div>
                          </div>

                        </div>
                        <div className="lets_customs_div_reacts_round1">
                          <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">
                              {(rfqVendorsEle?.technicalSpecification?.length < 1) && <>
                                <p className="tender_drawing_f">Empty</p>
                              </>}
                              {rfqVendorsEle?.technicalSpecification?.map((attachmentEle, j) => <>
                                <p className="tender_drawing_f" onClick={() => downloadAttachment(attachmentEle?.key, attachmentEle?.fileName, "technicalSpecification", i, j)}>
                                  {attachmentEle?.fileName}<img src={download1Image} alt="" />
                                </p>
                              </>)}
                            </div>
                          </div>
                        </div>

                        <p class="yes_technical_project_react_body1se">
                          {rfqVendorsEle?.technicalStatus}
                        </p>
                      </td>
                    </>)}

                  </tr> */}

                  {/* <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="paymentTerms"
                              value={rfqVendorsEle?.commercialFields?.paymentTerms}
                              disabled
                            // onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}

                  </tr> */}

                  {/* <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="liquidatedDamages"
                              value={rfqVendorsEle?.commercialFields?.liquidatedDamages}
                              disabled
                            // onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>

                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="overAllLdCap"
                              value={rfqVendorsEle?.commercialFields?.overAllLdCap}
                              disabled
                            // onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="defectLiabilityPeriod"
                              value={rfqVendorsEle?.commercialFields?.defectLiabilityPeriod}
                              disabled
                            // onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="serviceContractPeriod"
                              value={rfqVendorsEle?.commercialFields?.serviceContractPeriod}
                              disabled
                            // onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="warranty"
                              value={rfqVendorsEle?.commercialFields?.warranty}
                              disabled
                            // onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="capacity"
                              disabled
                              value={rfqVendorsEle?.commercialFields?.capacity}
                            // onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr> */}
                  <tr class="custom-borders" style={{ height: "46px" }}></tr>
                  {showalldocuments ? <>

                    {commercialEvaluationDetails?.rfqVendors[0]?.documents?.map((rfqVendorsDocEle, i) => <>
                      <tr class="custom-borders">
                        {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                          <td>
                            {/* <span>
                                <p className="rejected_text_table_redfm">Rejected</p>
                            </span> */}
                            <button className="file-upload-btn comparison-file-upload-btn" disabled=""
                              onClick={() => handleClick1(rfqVendorsEle?.documents[i], i)}
                            >View</button>
                          </td>
                        </>)}
                      </tr>
                    </>)}

                    {/* <tr class="custom-borders">
                          <td>
                            <div className="d-flex justify-content-between">
                              <div className="evaluation_react_bvfdt_div_block1">
                              <p className="rejected_text_table_redfm">Rejected</p>
                              <AttachFileIcon  style={{color:"#B9AFAF"}}/>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="d-flex justify-content-between">
                              <div className="evaluation_react_bvfdt_div_block1">
                              <p className="rejected_text_table_redfm">Rejected</p>
                              <AttachFileIcon  style={{color:"#B9AFAF"}}/>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="d-flex justify-content-between">
                              <div className="evaluation_react_bvfdt_div_block1">
                              <p className="rejected_text_table_redfm">Rejected</p>
                              <AttachFileIcon  style={{color:"#B9AFAF"}}/>
                              </div>
                            </div>
                          </td>
                          </tr> */}

                    {/* <tr class="custom-borders">
                          <td style={{border: "none"}}>
                          

                          </td>

                          <td style={{border: "none"}}>


                          </td>

                          <td style={{border: "none"}}>
                            <div className="btn custome_vendor_subnu_react_div">
                            <button type="button" class="btn btn-danger" fdprocessedid="7lvn2c">Discard </button>
                            <button type="button" class="btn-btn-submit_boq-div_commercial" fdprocessedid="u8jto">Submit</button>
                            </div>

                          </td>


                          </tr> */}
                  </> : null}
                </tbody>
              </table>
            </div>
          </div>

          {(isEditManually == true) && <div class="clear_btn_status_modified_boqs">
            <button type="button" class="btn clear_btn_status_block_lists" onClick={onClearData}>
              Clear
            </button>
            <button type="button" class="btn btn-success save_next_btns" onClick={onSubmitData}>

              Update Result
            </button>
          </div>}
          {/* <div class="comments_main">
            <h3>Comments</h3>
            <div class="comments_main_in">
              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input type="text" placeholder="Type comments..." />

                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="epy4fp"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="5izdv"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {(commercialEvaluationDetails?.rfqVendors?.length > 0) && (
        <>
          {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, i) => <>
            <SupportChat
              vendorDetails={{ vendor: { _id: rfqVendorsEle?.vendorId } }}
              isComparison={true}
              comparisonData={{
                isActive: rfqVendorsEle?.vendorId == activeChatVendorId,
                vendorName: rfqVendorsEle?.vendorName,
                rfqId: id,
                isVendorChatBoxOpen: isVendorChatBoxOpen,
              }}
              onMinimize={handleChatboxMinimize}
            />
          </>)}
        </>
      )}


      {/* Approve RFQ Publish in RFQ Listing */}
      <Modal
        open={openDownloadResultmodal}
        onClose={() => setOpenDownloadResultModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1} className="modal_react_controlpanel_employees">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">Download Result</h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => setOpenDownloadResultModal(false)}
            ></button>
          </div>
          <div class="modal-bodys">
            <div className="rfq-download-result-div">
              <div >
                <span><input name="Pdf" type="checkbox" checked={selectedCheckBox == "Pdf"} onChange={(e) => onSelectedCheckBox(e, "Pdf")} /> </span>
                <span>PDF </span>
              </div>
              <div onClick={() => setSelectedCheckBox("Excel")}>
                <span><input name="Excel" type="checkbox" checked={selectedCheckBox == "Excel"} onChange={(e) => onSelectedCheckBox(e, "Excel")} /> </span>
                <span>Excel </span>
              </div>
              <div onClick={() => setSelectedCheckBox("Both")}>
                <span><input name="Both" type="checkbox" checked={selectedCheckBox == "Both"} onChange={(e) => onSelectedCheckBox(e, "Both")} /> </span>
                <span>Both </span>
              </div>
            </div>
            <div class="lets_no_btn_danger_yes_technical_project">
              <button
                type="button"
                class="btn btn btn-danger"
                onClick={() => {
                  setOpenDownloadResultModal(false);
                }}
                style={{ "marginRight": "5px" }}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${selectedCheckBox ? 'btn-success' : ''}`}
                onClick={downloadRfqResult}
                disabled={!selectedCheckBox}
                variant="contained"
              >
                Submit
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <PackageDocuments
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={document}
        onUploadMedia={onUploadMedia}
        deleteFile={deleteFile}
        isSubmitCondition={false}
        isColumn={{
          "DELETE": true, // getRFQDocPermission(uploadFilesObj)?.update,
          "INPUT_UPLOAD": isMediaUploadSecName != "", // getRFQDocPermission(uploadFilesObj)?.update,
          "STATUS": false,
          "VENDOR_DOC": false,
          "REMARKS": false,
        }}
        handleUploadStatus={handleUploadStatus}
      />
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default CommercialComparison;
